export default null;

export { default as captcha_basic } from 'captcha_basic';
